'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

(function () {
  var enterModule = require('react-hot-loader').enterModule;

  enterModule && enterModule(module);
})();

var BRANDING_SERVICE_API_URL = 'https://api.branding.cimpress.io/v0/brands';

var fetchBrandingInfo = exports.fetchBrandingInfo = function fetchBrandingInfo(accessToken) {
  return fetch(BRANDING_SERVICE_API_URL, {
    method: 'GET',
    mode: 'cors',
    headers: new Headers({
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + accessToken
    })
  }).then(function (response) {
    if (response.status === 200) {
      return response.json().then(function (results) {
        if (results.total < 1) {
          // we must get at least 1 brand
          return null;
        }

        return results._embedded.item[0];
      });
    } else {
      return null;
    }
  }).catch(function (error) {
    console.error(error);
    return null;
  });
};

;

(function () {
  var reactHotLoader = require('react-hot-loader').default;

  var leaveModule = require('react-hot-loader').leaveModule;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(fetchBrandingInfo, 'fetchBrandingInfo', 'src/services/branding.js');
  reactHotLoader.register(BRANDING_SERVICE_API_URL, 'BRANDING_SERVICE_API_URL', 'src/services/branding.js');
  leaveModule(module);
})();

;